import { SORT_NEGATIVE } from '../similarGenres-process/selectors'

import { GenreWithCurators, MergedGenres, SimilarGenre } from '.'

const genresSorter = (arr: GenreWithCurators[]): GenreWithCurators[] =>
  [...arr].sort((a, b) => {
    if (!a?.genre_name || !b?.genre_name) {
      return 0
    }
    if (a?.genre_name < b?.genre_name) {
      return SORT_NEGATIVE
    }
    if (a?.genre_name > b?.genre_name) {
      return 1
    }
    return 0
  })

export const mergeCampaignGenres = (
  similarGenres: SimilarGenre[],
  allGenres: GenreWithCurators[],
): MergedGenres => {
  const filteredSimilar = similarGenres.filter((item) =>
    allGenres.some((genre) => genre.id === item.id),
  )

  const filteredAllGenres = allGenres.filter(
    (genreFromAll) =>
      !filteredSimilar.some(
        (genreFromSimilar) => genreFromAll.id === genreFromSimilar.id,
      ),
  )
  const filteredRecommended = allGenres.filter((genreFromAll) =>
    filteredSimilar.some(
      (genreFromSimilar) => genreFromAll.id === genreFromSimilar.id,
    ),
  )
  return {
    recommended: genresSorter(filteredRecommended),
    allGenres: genresSorter(allGenres),
    filteredAllGenres: genresSorter(filteredAllGenres),
  }
}
